"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recipientEpics = exports.tryCreateRecipientEpic = exports.recipientCreateEpic = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxObservable = require("redux-observable");

var R = _interopRequireWildcard(require("ramda"));

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _recipient = require("./recipient.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var renameRecipientKeys = (0, _utils.renameKeys)({
  country: 'country_id',
  email: 'email',
  employment: 'employment',
  firstName: 'first_name',
  lastName: 'last_name',
  phone: 'phone',
  employmentPosition: 'employment_position'
});

var recipientCreateEpic = function recipientCreateEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_recipient.CREATE_GIFT_RECIPIENT_CREATE_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.createRecipient(R.evolve({
      country_id: function country_id(id) {
        return parseInt(id, 10);
      }
    }, renameRecipientKeys(_objectSpread(_objectSpread({}, action.payload), {}, {
      skip_email_verification: true
    })))).pipe((0, _operators.map)(function (response) {
      return (0, _recipient.createRecipientSuccess)(response.contact);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _recipient.createRecipientFail
    })));
  }));
};

exports.recipientCreateEpic = recipientCreateEpic;

var tryCreateRecipientEpic = function tryCreateRecipientEpic(action$, state$, _ref2) {
  var createGiftService = _ref2.createGiftService,
      errorHandler = _ref2.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_recipient.CREATE_GIFT_RECIPIENT_CREATE_REQUEST_TRY), (0, _operators.mergeMap)(function (_ref3) {
    var _ref3$payload = _ref3.payload,
        recipient = _ref3$payload.recipient,
        skipEmailVerification = _ref3$payload.skipEmailVerification;
    return createGiftService.createRecipient(renameRecipientKeys(_objectSpread(_objectSpread({}, recipient), {}, {
      skip_email_verification: skipEmailVerification
    }))).pipe((0, _operators.map)(function (response) {
      if (!response.contact && response.is_unsubscribed) {
        return (0, _recipient.createRecipientSetIsUnsubscribed)(true);
      }

      if (!response.contact && !response.is_email_verified) {
        return (0, _recipient.createRecipientEmailInvalid)();
      }

      return (0, _recipient.createRecipientSuccess)(response.contact);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _recipient.createRecipientFail
    })));
  }));
};

exports.tryCreateRecipientEpic = tryCreateRecipientEpic;
var recipientEpics = [recipientCreateEpic, tryCreateRecipientEpic];
exports.recipientEpics = recipientEpics;